<div class="confirmation-padding">
  <div mat-dialog-title>
    {{ data.title }}
  </div>
  <div mat-dialog-content>
    <div class="message">{{ data.message }}</div>
    <br />
    @if (data.bulletList) {
    <ul>
      @for (message of data.bulletList; track message) {
      <li>
        {{ message }}
      </li>
      }
    </ul>
    } @if (data.messageLista) {
    <div>
      @for (message of data.messageLista; track message) {
      <div class="message-list">
        {{ message }}
      </div>
      }
    </div>
    } @if (data.customActionButton) {
    <div class="custom-action-container">
      <button
        mat-raised-button
        color="primary"
        (click)="onCustomAction()"
        class="custom-action-button"
      >
        {{ data.customActionButton }}
      </button>
    </div>
    } @if (data.useInput) {
    <faxe-input-form
      formCtrlName="input"
      inputType="text"
      inputModeType="text"
      [requiredInput]="true"
      [parentFormGroup]="formGroup"
    >
    </faxe-input-form>
    } @for (input of data?.inputs; track input) {
    <faxe-input-form
      [formCtrlName]="input.keyValuepair.key"
      [label]="input.label"
      [hint]="input.hint"
      [inputType]="input.inputType || 'text'"
      inputModeType="text"
      [autocomplete]="input.autocomplete || 'off'"
      [name]="input.name || input.keyValuepair.key"
      [requiredInput]="true"
      [parentFormGroup]="formGroup"
    ></faxe-input-form>
    }
  </div>
  <div class="action-buttons">
    <div mat-dialog-actions>
      @if (data.primaryButton) {
      <button
        mat-button
        color="primary"
        (click)="onPrimaryButton()"
        class="button-margin buttons"
      >
        {{ data.primaryButton }}
      </button>
      } @if (data.secondaryButton === buttons.avbryt) {
      <button
        mat-button
        color="secondary"
        (click)="onSecondaryButton()"
        class="buttons"
      >
        {{ data.secondaryButton }}
      </button>
      }
    </div>
  </div>
</div>
